import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import toast from 'react-hot-toast'

export function OAuthSuccessPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { refreshUser } = useAuth()

  useEffect(() => {
    const handleOAuthSuccess = async () => {
      const accessToken = searchParams.get('access_token')
      const refreshToken = searchParams.get('refresh_token')
      const returnUrl = searchParams.get('return_url') || '/dashboard'
      const isWelcome = searchParams.get('welcome') === 'true'

      if (!accessToken || !refreshToken) {
        toast.error('OAuth authentication failed')
        navigate('/auth/login')
        return
      }

      // Store tokens
      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('refreshToken', refreshToken)

      try {
        // Refresh user data
        await refreshUser()
        
        if (isWelcome) {
          toast.success('Welcome! Your account has been created successfully.')
        } else {
          toast.success('Successfully logged in!')
        }
        
        navigate(returnUrl)
      } catch (error) {
        console.error('Failed to load user data:', error)
        toast.error('Failed to complete login')
        navigate('/auth/login')
      }
    }

    handleOAuthSuccess()
  }, [searchParams, navigate, refreshUser])

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing login...</p>
      </div>
    </div>
  )
}